export default {
  pageDesc: 'Pick and check stations are paired by process type; each station maps to one seeding rack (4×9 = 36 slots)',
  summary: 'Pick {pick} · Check {check}',
  refresh: 'Refresh',
  refreshed: 'Station and seeding rack status refreshed',
  flowTitle: 'Station & Process Assignment',
  flowHint: 'Full-process stations handle pick + check; pick-only / check-only stations handle one step',
  colStation: 'Station',
  colType: 'Type',
  colWall: 'Rack Code',
  colFlows: 'Process Types',
  colOrders: 'Orders',
  colUsed: 'Slots Used',
  colRunning: 'Current Job',
  typePick: 'Pick Station',
  typeCheck: 'Check Station',
  flowAll: 'Full Process',
  flowPick: 'Pick',
  flowChk: 'Check',
  lampTitle: 'Seeding Rack Lights',
  lampHint: 'Pick side: 4 states · Check side: 3 states · Shared rack codes',
  lampOff: 'Off',
  lampOffDesc: 'Idle, or order assigned but not yet seeding',
  lampGreen: 'Green · Pending seed',
  lampGreenDesc: 'Lit after seed command; number shows remaining qty',
  lampBlue: 'Blue END',
  lampBlueDesc: 'Order fully seeded; waiting to push to check side',
  lampRed: 'Red FF',
  lampRedDesc: 'Pushed to check side; awaiting check',
  lampNotePickLabel: 'Pick side',
  lampNotePick: ': Off = idle/assigned · Green + qty = pending · Blue END = done · Red FF = pushed to check.',
  lampNoteCheckLabel: 'Check side',
  lampNoteCheck: ': Off = idle · Red = pending check · Green = checked, waiting return; check side shows color only.',
  lampNoteCode: 'Slot code',
  lampNoteCodeEx: 'B103A-19-A9',
  lampNoteCodeRule: '= station B103A · rack face 19 · row A col 9.',
  pickSection: 'Pick Stations',
  pickSectionHint: 'Each card = one station + one rack; order progress listed below',
  checkSection: 'Check Stations',
  checkSectionHint: 'Check side shows light color only; red means pending check',
  orderCount: '{n} orders',
  wallMeta: 'Rack {code} · {area}',
  usedFramesLabel: 'Used',
  freeFramesLabel: 'Free',
  freeFramesUnit: 'slots',
  occupyRateLabel: 'Occupancy',
  lampPickGreen: 'Green pending',
  lampPickBlue: 'Blue END done',
  lampPickRed: 'Red FF to check',
  lampCheckRed: 'Red pending',
  lampCheckGreen: 'Green checked',
  lampIdle: 'Off = idle / assigned',
  framePos: 'Slot {pos}',
  skuCount: '{n} SKU',
  qtyProgress: '{done}/{need}',
  badgePicking: 'Picking',
  badgeComplete: 'Complete',
  badgePendingCheck: 'Pending',
  badgeChecked: 'Checked',
  cellIdle: 'Idle',
  cellTip: '{station} · {code}-{pos} · {detail}',
  cellTipBusy: '{order} · {skuCount} SKUs · {done}/{need} pcs',
  cellTipOrder: '{order}',
  orderBound: 'Bound',
}
